<template lang="pug">
  .component-backoffice-note-list.row.column
    .row
      .column
        label Priority
          select(v-model="search.priority")
            option(:value="null") All priorities
            option(value="1") Minor
            option(value="2") Medium
            option(value="3") Major
      .column(v-if="filters && !filters.hasOwnProperty('vehicle_id')" )
        selectize-vehicle(v-model="search.vehicle_id", value-field="id" )
      .column
        label Type
          select(v-model="search.type")
            option(:value="null") All types
            option(value="CLEANING") Cleaning
            option(value="ROUTINE") Routine
            option(value="PREPARATION") Preparation
            option(value="CHECK_OUT") Check-out
            option(value="REPOSITIONING") Repositioning
            option(value="ACCIDENT") Accident
            option(value="EXTERIOR_REPAIR") Exterior repair
            option(value="RECHARGE") Recharge
            option(value="LOW_BATTERY") Low Battery
      .column
        label Status
          select(v-model="search.status" )
            option(:value="null") All statuses
            option(value="NEW") New
            option(value="ASSIGNED") Assigned
            option(value="IN_PROGRESS") In progress
            option(value="COMPLETED") Completed
            option(value="REFUSED") Refused
    base-list(:component="component", :dataLoader="dataLoader", ref="baseList", :component-type="listingType", :search="search")
</template>

<script>

import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import BaseList from "./BaseList";
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";

export default {
  name: "MaintenanceRequestList",
  components: {SelectizeVehicle, BaseList},
  data() {
    return {
      search: {
        type: null,
        priority: null,
        status: null,
        vehicle_id: null,

      },
      component: require('src/components/backoffice/InterventionRequest'),
    }

  },
  created() {
  },
  methods: {
    dataLoader(callback, page, resultsPerPage, search) {
      const body = {
        ...search,
        ...this.filters
      }
      KeplerBackofficeSdk.maintenanceRequest.list(page, resultsPerPage).all(body, (data) => {
        callback(data)
      })
    },
  },
  props: {
    filters: {
      type: Object,
      default: () => {
      }
    },
    listingType: {
      type: String,
      default: "listing"
    }
  }
}
</script>

<style scoped lang="sass">
.component-backoffice-zone-list
  .map
    height: 400px

  .zone-edit
    color: white

</style>



// WEBPACK FOOTER //
// MaintenanceRequestList.vue?429e398f